// Fusion feature switch that swaps the orders tab from Your Latest Orders to Active
// Deliveries & Pickups. Off or missing means Your Latest Orders, as before (WOR2-1058).
export const ACTIVE_ORDERS_FEATURE_SWITCH = 'fs:isProSnapshotActiveOrdersEnabled';

const LATEST_ORDERS_TAB = {
  key: 'latestOrders',
  label: 'Your Latest Orders',
};

const ACTIVE_ORDERS_TAB = {
  key: 'activeOrders',
  label: 'Active Deliveries & Pickups',
};

const PLANNING_TOOL_TABS = [
  {
    key: 'projects',
    label: 'Projects',
  },
  {
    key: 'lists',
    label: 'Lists',
  },
  {
    key: 'quotes',
    label: 'Quotes',
  },
];

// Static per-tab presentation, in the order the comps show them. Tab content is rendered
// per tab by SnapshotTabView, which hands each tab's slot to its own card component —
// every card (including LatestOrdersCard) owns its own loading/error/empty states. The
// orders tab keeps the first position under either switch state.
export const TAB_META = [LATEST_ORDERS_TAB, ...PLANNING_TOOL_TABS];
export const ACTIVE_ORDERS_TAB_META = [ACTIVE_ORDERS_TAB, ...PLANNING_TOOL_TABS];

// Shared with LatestOrdersCard, the one card that renders its own SnapshotPodPanel and
// so needs an emptyText to pass it.
export const LATEST_ORDERS_EMPTY_TEXT = 'No recent orders to show right now.';

// Shown instead of LATEST_ORDERS_EMPTY_TEXT when the purchaseHistory query itself failed,
// so a real error doesn't read as "you have no orders".
export const LATEST_ORDERS_ERROR_TEXT = 'We couldn’t load your recent orders. Please try again later.';

// Same purchase-history page linked from customer-account-navigation's own "Purchase
// History" route — the canonical destination for a customer's full order list.
export const VIEW_ALL_ORDERS_URL = '/myaccount/purchase-history';
